import React, { createContext, useContext } from 'react';

type TabsContextValue = {
  activeTab: string;
};

const TabsContext = createContext<TabsContextValue | null>(null);

function useTabsContext(): TabsContextValue {
  const ctx = useContext(TabsContext);
  if (!ctx) {
    throw new Error('TabPane must be used within <TabContent>.');
  }
  return ctx;
}

export interface TabContentProps extends React.HTMLAttributes<HTMLDivElement> {
  activeTab: string;
  className?: string;
  children: React.ReactNode;
}

export const TabContent: React.FC<TabContentProps> = ({ activeTab, className = '', children, ...props }) => {
  return (
    <TabsContext.Provider value={{ activeTab }}>
      <div className={className} {...props}>
        {children}
      </div>
    </TabsContext.Provider>
  );
};

export interface TabPaneProps extends React.HTMLAttributes<HTMLDivElement> {
  tabId: string;
  className?: string;
  children: React.ReactNode;
}

export const TabPane: React.FC<TabPaneProps> = ({ tabId, className = '', children, ...props }) => {
  const { activeTab } = useTabsContext();
  if (activeTab !== tabId) return null;
  return (
    <div className={className} {...props}>
      {children}
    </div>
  );
};
